import capaTelefoneFoto from '../../assets/images/capaTELEFONE.jpeg';

import './PlanosPremium.css';

const CapaTelefone = () => {
  return (
    <div className='container-fluid'>
      <div className="planos-header">
          <span className="planos-badge">Telefone Fixo</span>
          <h2>Escolha o seu plano ideal</h2>
         
        </div>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='foto-gamer'>
            <img src={capaTelefoneFoto} alt="foto-gamer" />
          </div>
        </div>
      </div>
      <br /> <hr />
    </div>
  )
}
export default CapaTelefone;